import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import "./AllProjects.css";
import AllProjectsHero from "../../components/pages/AllProjects/AllProjectsHero/AllProjectsHero";
import ExploreAllProjects from "../../components/pages/AllProjects/ExploreAllProjects/ExploreAllProjects";
import AboutStartNewProject from "../../components/pages/About/AboutStartNewProject/AboutStartNewProject";
import {
  findPageSection,
  getAboutStartNewProjectContent,
  unwrapSectionData,
} from "../../utils/aboutStartNewProjectSection";
import { usePageContent, usePageContentAliases } from "../../hooks/usePublicQueries";

const PROJECTS_PAGE_ALIASES = ["allprojects", "all-projects", "projects", "allproject"];

const AllProjects = () => {
  const { i18n } = useTranslation();
  const { data: pageContent } = usePageContentAliases(PROJECTS_PAGE_ALIASES, i18n.language);
  const { data: aboutContent } = usePageContent("about", i18n.language);

  const heroSection = useMemo(
    () =>
      findPageSection(pageContent, "hero") ||
      findPageSection(pageContent, "allprojectshero") ||
      findPageSection(pageContent, "allprojects"),
    [pageContent]
  );

  return (
    <div className="allprojects-page">
      <Navbar />
      <AllProjectsHero content={unwrapSectionData(heroSection)} />
      <div className="allprojects-page-content-guide">
        <div id="all-projects-explore">
          <ExploreAllProjects />
        </div>
        <AboutStartNewProject content={getAboutStartNewProjectContent(aboutContent)} />
      </div>
      <Footer />
    </div>
  );
};

export default AllProjects;
